import Swiper, { Navigation } from 'swiper';
import comments from '@js/components/comments';

Swiper.use([Navigation]);

export default {
  init() {
    this.eventSlider();
    comments.init();
  },

  eventSlider() {
    const eventWrapEl = $('.event-slider-wrap');
    const eventSliderEl = eventWrapEl.children('.event-slider');
    const breakpoint = window.matchMedia('(min-width:900px)');
    let eventSwiper;

    const breakpointChecker = function () {
      if (breakpoint.matches === true) {
        if (eventSwiper !== undefined) {
          eventSwiper.destroy(true, true);
        }

        return;
      } else if (breakpoint.matches === false) {
        eventSwiper = new Swiper(eventSliderEl[0], {
          slidesPerView: 2,
          spaceBetween: 16,
          navigation: {
            prevEl: eventWrapEl.find('.swiper-button--prev')[0],
            nextEl: eventWrapEl.find('.swiper-button--next')[0],
          },
        });
      }
    };

    // keep an eye on viewport size changes
    breakpoint.addEventListener('change', breakpointChecker);

    // kickstart
    breakpointChecker();
  },

  finalize() {},
};
